<template>
  <div class="message text-body1" :class="[type]">
    <slot />
  </div>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.message {
    padding: 1rem;
    border-radius: 4px;
    border-width: 1px;
    border-left-width: 5px;
    border-style: solid;
    &.info {
        border-color: $blue-4;
        background: $blue-1;
    }
    &.positive {
        border-color: $green-4;
        background: $green-1;
    }
    &.negative {
        border-color: $red-4;
        background: $red-1;
    }
    &.warning {
        border-color: $yellow-4;
        background: $yellow-1;
    }
}

</style>

<script>

export default {
  props: {
    type: {
      type: String,
      default: 'info',
    },
  },
};
</script>
